import myTraderaItemActions from './my-tradera-items';
import qs from 'qs';
import { checkStateOfQueryParams } from '../../helpers/route-helper';
import {
    selectCookiesState,
    setCookie
} from 'tradera-apps/my-tradera/app/state/reducers/cookies';
import { selectMyTraderaState } from 'tradera-apps/my-tradera/app/state/reducers/my-tradera';
import {
    setFiltersFromRouter,
    updateFiltersForSelectedPage,
    updatePageSize
} from 'tradera-apps/my-tradera/app/state/reducers/filters';

export const setPageSize = value => dispatch => {
    dispatch(
        setCookie({
            name: 'ITEMS_PER_PAGE',
            value
        })
    );
    dispatch(updatePageSize({ size: value }));
};

export const setFiltersForSelectedPage = ({ newFilters, defaultFilters }) => (
    dispatch,
    getState
) => {
    const pageSize = selectCookiesState(getState()).ITEMS_PER_PAGE;
    if (pageSize) {
        // eslint-disable-next-line better-mutation/no-mutation
        newFilters.modifiers.paging.size = pageSize;
    }
    dispatch(updateFiltersForSelectedPage({ newFilters, defaultFilters }));
};

export const historyLocationDidUpdate = history => (dispatch, getState) => {
    const isPrevAndCurrentPathnameEqual = () => {
        const routingState = getState().router;
        return (
            routingState.location &&
            routingState.location.pathname &&
            routingState.location.pathname === history.location.pathname
        );
    };

    const { location } = history;

    if (history.action === 'POP' && isPrevAndCurrentPathnameEqual()) {
        if (
            checkStateOfQueryParams(getState, location.search) &&
            selectMyTraderaState(getState()).isSearching === false
        ) {
            const { filters } = qs.parse(location.search.replace('?', ''));
            dispatch(setFiltersFromRouter({ filters }));
            dispatch(myTraderaItemActions.updateURL());
        }
    } else if (history.action === 'PUSH' && !isPrevAndCurrentPathnameEqual()) {
        if (
            checkStateOfQueryParams(getState, location.search) &&
            selectMyTraderaState(getState()).isSearching === false
        ) {
            const { filters } = qs.parse(location.search.replace('?', ''));
            dispatch(setFiltersFromRouter({ filters }));
            dispatch(myTraderaItemActions.updateURL());
        }
    }
};

export const showHideFilterToolbar = showCookies => dispatch => {
    dispatch(
        setCookie({
            name: 'SHOW_FILTERS',
            value: showCookies === 'visible' ? 'hidden' : 'visible'
        })
    );
};
